// Plugin lsAutomation (Link Studios). Generado por huly-automation/patch/apply.sh
import { addLocation, addStringsLoader } from '@hcengineering/platform'
import { lsAutomationId } from '@hcengineering/ls-automation'
import '@hcengineering/ls-automation-assets'

export function configureLsAutomation (): void {
  addStringsLoader(lsAutomationId, async (lang: string) => await import(`@hcengineering/ls-automation-assets/lang/${lang === 'es' ? 'es' : 'en'}.json`))
  addLocation(lsAutomationId, async () => await import(/* webpackChunkName: "ls-automation" */ '@hcengineering/ls-automation-resources'))
}
